import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DamageReportStep } from '../../models';
import { CreateDamageReportService } from '../../create-damage-report.service';
import { PortalActionButtonsComponent, PortalWidgetDetailsComponent } from 'app/customer-portal/components';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { DamageReportStepHeaderComponent } from '../../components/damage-report-step-header/damage-report-step-header.component';

@Component({
    selector: 'app-damage-report-summary-step',
    imports: [
        PortalWidgetDetailsComponent,
        PortalActionButtonsComponent,
        CtrlIconComponent,
        DamageReportStepHeaderComponent,
    ],
    templateUrl: './damage-report-summary-step.component.html',
    styleUrl: './damage-report-summary-step.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DamageReportSummaryStepComponent implements DamageReportStep {
    @Input()
    public isFirst = false;

    @Input()
    public fileAttachmentFormSlug = 'dateien-hochladen';

    @Output()
    public onPrev = new EventEmitter<void>();

    @Output()
    public onNext = new EventEmitter<void>();

    @Output()
    public onCancel = new EventEmitter<void>();

    @Output()
    public onSubmit = new EventEmitter<void>();

    @Output()
    public navigate = new EventEmitter<string>();

    protected reportForm = inject(CreateDamageReportService).reportForm;
    protected filesForm = inject(CreateDamageReportService).filesForm;
}
